import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import GoUpBtn from '../../common/GoUpBtn';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import RangeSlider from '../../common/RangeSlider';
import SportSelectionMenu from '../../common/SportSelectionMenu';
import PrematchContext from '../../contexts/PrematchContext';
import { getMainAgg } from '../../data/data';
import { useFetchFavoriteOdds } from '../../data/fetchFavoriteOdds';
import { byRankingAndTime, enableDisableOdds } from '../../data/parseFavoriteOdds';
import { classIf, filterMatchesByTimestamp, filtraParametriche, getBetDescription, getConfiguration, getFilterDesc, oddToString } from '../../data/utils';
import { ReactComponent as CloseIcon } from '../../icons/menu.svg';
import { getLabel } from '../../InitData';
import { adjustOddsAlignment } from '../../tables-utils';
import ButtonsContainer from '../prematch-home/ButtonsContainer';
import PrematchTournamentMatch from '../prematch-home/PrematchTournamentMatch';
import { RangeSliderNewWh } from '../../common/RangeSliderNewWh';
import { DateSelectionFavoriteOddsWh } from '../../common/DateSelectionFavoriteOddsWh';

const STEP = 20;
const ADVANCED_STEP = 50;

function applyFilters(data, sport, oddsFilterMin, oddsFilterMax, timeFilter, betId) {
    let events = data.eventsBySport.get(sport);
    events = filterMatchesByTimestamp(events, timeFilter)

    let key = `${oddsFilterMin}_${oddsFilterMax}`;
    let filtered = [];
    events.forEach(e => {
        if (e.filters.has(betId) && e.filters.get(betId).has(key)) {
            filtered.push(e);
        }
    });

    filtered = filtered.sort(byRankingAndTime);
    enableDisableOdds(filtered, oddsFilterMin, oddsFilterMax);
    return filtered;
}

function getPrintableOdds(odds) {
    return odds.map(o => oddToString(o));
}

function PrematchFavoriteOdds(props) {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);

    const times = conf.foc.tfs;
    const oddsValuesMin = conf.foc.ods;
    const oddsValues = conf.foc.ods;

    const timeout = useRef(null);
    const [state, setState] = useState({
        data: null,
        events: [],
        oddsFilter: oddsValues[1],
        oddsFilterMin: oddsValuesMin[conf.iwh ? 1 : 0],
        timeFilter: 'ALL',
        sport: null,
        betId: null,
        handicap: null,
        update(updt) {
            setState(prev => {
                return { ...prev, ...updt };
            });
        },
        setData(data) {
            const sport = data.sports[0].id;
            const firstBet = data.eventsBySport.get(sport)[0].gruppiScommessa[0].scommesse[0];
            const betId = `${firstBet.id}_${firstBet.handicap}`;
            const events = applyFilters(data, sport, this.oddsFilterMin, this.oddsFilter, this.timeFilter, betId);
            this.update({ data, sport, events, betId: betId });
        },
        changeSport(sportId) {
            clearTimeout(timeout.current);
            const firstBet = this.data.eventsBySport.get(sportId)[0].gruppiScommessa[0].scommesse[0];
            const betId = `${firstBet.id}_${firstBet.handicap}`;
            const events = applyFilters(this.data, sportId, this.oddsFilterMin, this.oddsFilter, this.timeFilter, betId);
            this.update({ sport: sportId, events, betId });
            setOffset(STEP);
        },
        changeOddsFilter(index) {
            clearTimeout(timeout.current);
            const oddsFilter = oddsValues[index];
            const events = applyFilters(this.data, this.sport, this.oddsFilterMin, oddsFilter, this.timeFilter, this.betId);
            this.update({ events, oddsFilter: oddsFilter });
            setOffset(STEP);
        },
        changeOddsFilterMin(index) {
            clearTimeout(timeout.current);
            const oddsFilterMin = oddsValuesMin[index];
            const events = applyFilters(this.data, this.sport, oddsFilterMin, this.oddsFilter, this.timeFilter, this.betId);
            this.update({ events, oddsFilterMin: oddsFilterMin });
            setOffset(STEP);
        },
        changeTimeFilter(index) {
            clearTimeout(timeout.current);
            const timeFilter = times[index];
            const events = applyFilters(this.data, this.sport, this.oddsFilterMin, this.oddsFilter, timeFilter, this.betId);
            this.update({ timeFilter, events });
            setOffset(STEP);
        },
        updateBetId(bet) {
            const betId = `${bet.id}_${bet.handicap}`;
            const events = applyFilters(this.data, this.sport, this.oddsFilterMin, this.oddsFilter, this.timeFilter, betId);
            this.update({ events, betId: betId });

        }
    });

    function handleOddsOnChange(i) {
        state.changeOddsFilter(i);
    }

    function handleOddsOnChangeMin(i) {
        state.changeOddsFilterMin(i);
    }

    function handleTimeOnChange(i) {
        state.changeTimeFilter(i);
    }

    function handleClose() {
        prematchContext.closeAllTournaments();
    }

    function openEvent(event) {
        const tournamentUniqueId = `${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
        prematchContext.openEvent(tournamentUniqueId, event);
    }

    function changeSport(sportId) {
        state.changeSport(sportId);
    }

    const [request] = useFetchFavoriteOdds();

    const [showLoader, setShowLoader] = useState(true);
    useEffect(function () {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function () {
                setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            setShowLoader(false);
            if (!request.isError) {
                state.setData(request.data);
            }
        }

        return () => {
            clearInterval(timeout);
        };
    }, [request]);

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    const [offset, setOffset] = useState(STEP);
    useEffect(() => {
        if (state.events.length > 0 && offset != null) {
            timeout.current = setTimeout(() => {
                let newOffset = offset;
                if (items.length + offset + ADVANCED_STEP >= state.events.length) {
                    newOffset = null;
                } else {
                    newOffset += ADVANCED_STEP;
                }
                setOffset(newOffset);
            }, 1000);
        }
    }, [state.events, offset]);

    let items = offset ? state.events.slice(0, offset) : state.events;
    const timeRanges = times.map(t => getFilterDesc(t));

    let fiveColumnTemplate = false;
    if (items[0]?.gruppiScommessa.length <= 1) {
        fiveColumnTemplate = true;
    }


    let mainBets = null;
    if (state.sport) {
        let bets = [];

        const agg = getMainAgg(false, state.sport);
        bets = agg.scommesse.filter(bet => {
            return !bet.parametrica && ![15, 16, 17].includes(bet.id);
        });

        mainBets = bets.map(bet => {
            function handleClick() {
                state.updateBetId(bet);
            }
            const isSelected = `${bet.id}_${bet.handicap}` === state.betId;
            return (
                <div key={`${bet.id}_${bet.handicap}`} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter Zprincipali elementoDropdown" + classIf(isSelected, 'icona-selezionata')} onClick={handleClick}>
                    <p>{getBetDescription(bet, true)}</p>
                </div>
            );
        });
    }

    if (!showLoader) {
        items = items.map(item => {
            const bets = item.gruppiScommessa[0].scommesse.filter(s => {
                return `${s.id}_${s.handicap}` === state.betId;
            });
            return { ...item, bets, gruppiScommessa: [{ scommesse: bets }] };
        })
    }

    return (
        <div className="griglia-centrale-sport col stringimento-sidebar sb-1" id="xs-favorite-odds">
            <div className="contenitore-schedine-sport">
                <div className="competizione-interna dueColonne dueColonne_Template_1 unaColonna">
                    <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin">
                        <GoUpBtn />
                        <div className="titolo-blocco-sport bg-nero bianco pointer">
                            <i className="fa fa-times margine-dx align-self-center" onClick={handleClose}></i>
                            <div className="nome-competizione-sport">
                                <span className="grassetto">{getLabel('favorite_odds')}</span>
                            </div>
                            <div className="icone-controllo-sport-centrale">
                                <CloseIcon className="pointer" onClick={handleClose} />
                            </div>
                        </div>
                        {showLoader || request.isError ?
                            <Loader error={request.isError} />
                            :
                            <>    {!conf.iwh &&


                                (<div className="d-flex justify-content-center w-100">
                                    <div id="fav-odds-max-odd-value" className="d-flex flex-column align-items-center">
                                        <span>{getLabel('favorite_odds.min_odd_value')}</span>
                                        <RangeSlider elems={getPrintableOdds(oddsValuesMin)} defaultValue={0} onChange={handleOddsOnChangeMin} />
                                    </div>
                                    <div id="fav-odds-max-odd-value" className="d-flex flex-column align-items-center">
                                        <span>{getLabel('favorite_odds.max_odd_value')}</span>
                                        <RangeSlider elems={getPrintableOdds(oddsValues)} defaultValue={1} onChange={handleOddsOnChange} />
                                    </div>
                                    <div id="fav-odds-time-limit" className="d-flex flex-column align-items-center">
                                        <span>{getLabel('favorite_odds.time_limit')}</span>
                                        <RangeSlider elems={timeRanges} defaultValue={times.indexOf('ALL')} onChange={handleTimeOnChange} />
                                    </div>
                                </div>)}
                                <div className="tab-content d-flex position-relative">
                                    <div className="partite-del-giorno tab-pane fade show active overflow-visible d-flex no-margin" role="tabpanel">
                                        <SportSelectionMenu sports={state.data.sports}
                                            selected={state.sport}
                                            forceRows={false}
                                            showSortButton={false}
                                            changeSport={changeSport} />
                                    </div>
                                </div>
                                {conf.iwh ?
                                    <>
                                        <div className='favorite__odd-wrapper'>
                                            <div className='favoriteOdds__wrapper--wh'>
                                                <DateSelectionFavoriteOddsWh elems={timeRanges} defaultValue={times.indexOf('ALL')} onChange={handleTimeOnChange} />
                                                <RangeSliderNewWh elems={getPrintableOdds(oddsValues)}
                                                    defaultValueMin={oddsValues.indexOf(125)}
                                                    defaultValueMax={oddsValues.length - 2}
                                                    onChangeMin={handleOddsOnChangeMin}
                                                    onChangeMax={handleOddsOnChange} />
                                            </div>
                                        </div>
                                        <div className='favorite__odd-btn'>
                                            <ButtonsContainer id={state.sport} buttons={mainBets} aggregate={true}></ButtonsContainer>
                                        </div>
                                    </>
                                    :
                                    <ButtonsContainer id={state.sport} buttons={mainBets} aggregate={true}></ButtonsContainer>
                                }
                                {items.length > 0 ?
                                    <div className="partite-del-giorno tab-pane fade show active overflow-visible" role="tabpanel">
                                        <div className="contenitore-table-grande">
                                            <div>
                                                <div className="contenitore-table bg-bianco bordo-tondo" id="prematch-matches-container">
                                                    <div className={"tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch tabellaQuoteIntestazionePrematch_template-2 mb-2 " + (fiveColumnTemplate ? 'tabellaQuotePrematch_5col' : '')} >
                                                        <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                                                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                            <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                                        </div>
                                                        <div className="tabellaQuoteSquadre"></div>
                                                        <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                                            <BetsOddsHeader bets={filtraParametriche(items[0].gruppiScommessa[0].scommesse.filter(s => s.id !== 1 && `${s.id}_${s.handicap}` === state.betId))} matches={items[0].events} />
                                                        </div>
                                                        <div className="tabellaQuoteStatistiche"></div>
                                                        {!fiveColumnTemplate &&
                                                            <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                                                        }
                                                        <div className="tabellaQuoteTorneo d-flex align-items-center pl-1"></div>
                                                    </div>
                                                    {items.map(event =>
                                                        <PrematchTournamentMatch key={event.id} match={event} aggregata={props.aggregata} isLive={false} openMatch={openEvent} showTournamentDesc={true} />
                                                    )}
                                                    {(items.length < state.events.length) &&
                                                        <Loader />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <MessageInfo message={getLabel('favorite_odds.error.no_events_for_selected_filters')} />
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrematchFavoriteOdds;
